import { useIsMobile } from '@/hooks/use-is-mobile';
import { redirect, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

const CreateAccountDesktopRedirect = () => {
  const searchParams = useSearchParams();
  const { isMobile } = useIsMobile();

  useEffect(() => {
    if (!isMobile) {
      const queryStr = searchParams.toString();

      redirect('/sign-in' + (queryStr ? `?${queryStr}` : ''));
    }
  }, [searchParams, isMobile]);

  return null;
};

export default CreateAccountDesktopRedirect;
